import React, { useEffect, useRef, useState } from "react";
import DashboardLayout from "../../DashboardLayout";
import { Button, Form, Table } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsByGames } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import BSPagination from "../../../Components/pagination";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function TopGamesByAdViews() {
  const tableRef = useRef(null);
  const navigation = useNavigate();
  const [selectedGame, setSelectedGame] = useState("");
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({});

  const getAdsByGames = async (
    page = pagination?.currentPage || 1,
    pageSize = pagination?.pageSize || 10
  ) => {
    const res = await fetchAdsByGames(page, pageSize);
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
      setPagination(res?.data?.metadata || {});
      if (selectedGame) {
        const temp = res?.data?.data?.filter((f) => f.game_id == selectedGame);
        setFilteredData(temp);
      } else {
        setFilteredData(res.data.data);
      }
    } else {
      handleErrors(res, navigation);
    }
  };
  const handlePageChange = async (page) => {
    handleReset();
    await getAdsByGames(page, pagination.pageSize || 10);
  };
  const handleFilterChange = (e) => {
    setSelectedGame(e.target.value);
    if (e.target.value) {
      const temp = tableData?.filter((f) => f.game_id == e.target.value);
      setFilteredData(temp);
    } else {
      setFilteredData(tableData);
    }
  };

  const handleReset = () => {
    setSelectedGame("");
    setFilteredData(tableData);
  };

  const chartData = {
    labels: filteredData.map((item) => item.title),
    datasets: [
      {
        label: "Ad Views",
        data: filteredData.map((item) => item.total_ads),
        backgroundColor: "rgba(255, 206, 86, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        labels: {
          color: "#ffffff",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ffffff",
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#ffffff",
        },
      },
    },
  };

  useEffect(() => {
    getAdsByGames();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = filteredData.map((item) => {
      return [item.title, item.total_ads];
    });

    const config = {
      data: rows,
      columns: [{ title: "Game Name" }, { title: "Ad Views" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [filteredData]);

  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Game</h5>
          <div className="row align-items-center mb-3">
            <div className="col-md-3">
              <Form.Select
                className="bg-dark text-light border-light"
                value={selectedGame}
                onChange={handleFilterChange}
              >
                <option value="">All games</option>
                {tableData?.map((m) => (
                  <option value={m.game_id}>{m.title}</option>
                ))}
              </Form.Select>
            </div>
            <div className="col-md-2">
              <Button className="btn btn-success" onClick={handleReset}>
                Reset
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Top Games by Ad Views</h5>
          <p className="card-text">
            Which games generate the most ad impressions?
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {filteredData.length === 0 && (
              <p className="text-muted mt-3">No data available.</p>
            )}
          </div>
          <div className="constainer-fluid mt-2">
            <div className="d-flex justify-content-end">
              <div className="mx-4 py-2">
                <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
              </div>
              <BSPagination
                currentPage={parseInt(pagination?.currentPage)}
                totalPages={parseInt(pagination?.totalPages)}
                onPageChange={handlePageChange}
                siblingCount={2}
                showFirstLast={true}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Views by Game</h6>
          <Bar data={chartData} options={chartOptions} />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default TopGamesByAdViews;
